import { render } from "./refer.vue?vue&type=template&id=7383959b&scoped=true"
import script from "./refer.vue?vue&type=script&lang=js"
export * from "./refer.vue?vue&type=script&lang=js"

import "./refer.vue?vue&type=style&index=0&id=7383959b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7383959b"]])

export default __exports__